module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBlackItalic.3280f1f0.woff2";